import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import LoginCallback from "./authorization/LoginCallback";
import UserStatus from "./authorization/UserStatus";
import ServersListing from "./pages/ServersListing";
import Maps from "./pages/Maps";
import SpendingTimeline from "./charts/SpendingTimeline";
import SpendingBarChart from "./charts/SpendingBarChart";
import SpendingPieChart from "./charts/SpendingPieChart";
import TweetRenderer from "./twitter/TweetRenderer";
import TweetTest from "./twitter/TweetTest";


const Home = props => {
    return (
        <div>
            <h1>React Discord Login</h1>
            <UserStatus/>
            <button onClick={() => window.location = '/maps'}>Maps</button>
        </div>
    )
}

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Home/>}/>
                <Route path="/login-callback" element={<LoginCallback/>}/>
                <Route path="/loggedIn" element={<Home/>}/>
                <Route path="/servers" element={<ServersListing/>}/>
                <Route path="/maps" element={<Maps/>}/>
                <Route path="/charts/spending/timeline" element={<SpendingTimeline/>}/>
                <Route path="/charts/spending/bar" element={<SpendingBarChart/>}/>
                <Route path="/charts/spending/pie" element={<SpendingPieChart/>}/>
                <Route path="/tweet" element={<TweetRenderer/>}/>
                <Route path="/tweetTest" element={<TweetTest/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
